import React, { useEffect, useState } from "react";
import { FieldGroup } from "../../../../components";

const DetailInfoEditableRight = ({ data, possibleFeatures, setActiveItem }) => {
  const [model, setModel] = useState(data?.model ?? "");
  const [dialColor, setDialColor] = useState(data?.dial_color ?? "");
  const [braceletType, setBraceletType] = useState(data?.bracelet_type ?? "");
  const [size, setSize] = useState(data?.case_diameter ?? "");
  const [dialIndex, setDialIndex] = useState(data?.dial_indexes ?? "");
  const [referenceNumber, setReferenceNumber] = useState(
    data?.reference_number ?? ""
  );

  useEffect(() => {
    setActiveItem({
      brand: data?.brand,
      model: model,
      dial_color: dialColor,
      bracelet_type: braceletType,
      size: size,
      dial_index: dialIndex,
      reference_number: referenceNumber,
      image_url: data?.image_url,
      title: data?.title || "",
      case_diameter: data?.case_diameter || "",
      movement_details: data?.movement_details || "",
      case_glass: data?.case_glass || "",
      case_back: data?.case_back || "",
      case_water: data?.case_water || "",
      dial_indexes: data?.dial_indexes || "",
      case_material: data?.case_material || "",
      production_year: data?.production_year || "",
      movement_reference: data?.movement_reference || "",
    });
  }, [model, dialColor, braceletType, size, dialIndex, referenceNumber, data]);

  useEffect(() => {
    setModel(data?.model ?? "");
    setDialColor(data?.dial_color ?? "");
    setBraceletType(data?.bracelet_type ?? "");
    setSize(data?.case_diameter ?? "");
    setDialIndex(data?.dial_indexes ?? "");
    setReferenceNumber(data?.reference_number ?? "");
  }, [data]);

  return (
    <div className="detail-info border border-gray-200">
      <div className="detail-item border-bottom border-gray-200">
        {data?.brand ?? "Brand"}&nbsp;
      </div>

      <div className="border-bottom border-gray-200">
        <FieldGroup
          placeholder={model ?? "Model"}
          type="select"
          options={possibleFeatures.model_name.map((item) => {
            return { id: item, name: item };
          })}
          name="model"
          value={model}
          onChange={setModel}
          noFormik
        />
      </div>
      <div className="border-bottom border-gray-200">
        <FieldGroup
          placeholder={referenceNumber ?? "Reference Number"}
          type="text"
          name="reference_number"
          value={referenceNumber}
          onChange={(e) => setReferenceNumber(e.target.value)}
          noFormik
        />
      </div>
      <div className="border-bottom border-gray-200">
        <FieldGroup
          placeholder={dialColor ?? "Dail Color"}
          type="select"
          options={possibleFeatures.dial_color.map((item) => {
            return { id: item, name: item };
          })}
          name="dial_color"
          value={dialColor}
          onChange={setDialColor}
          noFormik
        />
      </div>
      <div className="border-bottom border-gray-200">
        <FieldGroup
          placeholder={braceletType ?? "Bracelet Type"}
          type="select"
          options={possibleFeatures.bracelet_type.map((item) => {
            return { id: item, name: item };
          })}
          name="bracelet_type"
          value={braceletType}
          onChange={setBraceletType}
          noFormik
        />
      </div>
      <div className="border-bottom border-gray-200">
        <FieldGroup
          placeholder={dialIndex ?? "Dial Index"}
          type="select"
          options={possibleFeatures.dial_index.map((item) => {
            return { id: item, name: item };
          })}
          name="dial_index"
          value={dialIndex}
          onChange={setDialIndex}
          noFormik
        />
      </div>
      <div className="border-bottom border-gray-200">
        <FieldGroup
          placeholder={size ?? "Size"}
          type="select"
          options={possibleFeatures.size.map((item) => {
            return { id: item, name: item };
          })}
          name="size"
          value={size}
          onChange={setSize}
          noFormik
        />
      </div>
    </div>
  );
};

export default DetailInfoEditableRight;
